import { ComponentLoader } from '@bythepixel/component-loader';

/**
 * Remounts the provided array of components to the context
 * of a specific HTML element, or the document
 *
 * @param { HTMLElement|Document } containerEl
 * @param { Array<Component> } components
 *
 * @returns { ComponentLoader }
 */
export default function reloadComponents(containerEl, components = []) {
  return new ComponentLoader(containerEl, components);
}
